module.exports = __webpack_public_path__ + "img/ol-pejeta-logo.f3f85739.svg";